<template>
  <i v-if="rawSvg" class="emh-ui-custom-icon" v-html="rawSvg" />
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';

export default defineComponent({
  name: 'UiCustomIcon',
  props: {
    name: { type: String, required: true },
  },
  setup(props) {
    const rawSvg = ref<string>();

    import(`../../assets/icons/${props.name}.svg?raw`).then((module) => {
      rawSvg.value = module.default;
    });

    return { rawSvg };
  },
});
</script>

<style lang="scss" scoped>
.emh-ui-custom-icon {
  display: inline-flex;
}
</style>
